import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { setTeamSettings } from '@/utils/teamSettingsCache';
import { getTeamSettingsApi } from '@/lib/team-api';

const refreshedTeamIds = new Set<string>();
const refreshingTeamIds = new Set<string>();

/**
 * A utility component that refreshes team settings when the app starts
 * It ensures settings are in sync with the database
 */
export function TeamSettingsRefresher() {
  const user = useAuthStore(state => state.user);
  const mergeActiveTeamSettings = useAuthStore(state => state.mergeActiveTeamSettings);
  
  useEffect(() => {
    const refreshTeamSettings = async () => {
      // Only try to refresh if we have an authenticated user with an active team
      if (!user?.token || !user?.active_team?.id) return;

      const teamId = user.active_team.id;

      if (user.active_team.settings) {
        setTeamSettings(teamId, user.active_team.settings);
      }

      if (refreshedTeamIds.has(teamId) || refreshingTeamIds.has(teamId)) return;
      refreshingTeamIds.add(teamId);

      try {
        const response = await getTeamSettingsApi();

        if (response.data?.settings) {
          mergeActiveTeamSettings(teamId, response.data.settings);
          refreshedTeamIds.add(teamId);
        } else if (response.error) {
          console.error('Error refreshing team settings:', response.error);
        }
      } catch (error) {
        console.error('Error refreshing team settings:', error);
      } finally {
        refreshingTeamIds.delete(teamId);
      }
    };
    
    void refreshTeamSettings();
    
  }, [
    mergeActiveTeamSettings,
    user?.token,
    user?.active_team?.id,
    user?.active_team?.settings,
  ]);
  
  // This component doesn't render anything
  return null;
} 